import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import Select from 'react-select';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { FormataTelefone } from '@/shared/utils/telefones';
import { GetDefensoria, SetDefensoria, DeleteDefensoria, GetDefensorias, } from '@/modules/structure/defensoria/defensoria.service';
import { GetDiretorias } from '@/modules/structure/diretoria/diretoria.service';
import { GetPredios } from '@/modules/structure/predio/predio.service';
import { useNavigate } from 'react-router-dom';
import { ReadDefensoriaDto } from '@/api.types';
import { SubmitHandler, useController, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { readVara } from '../vara/vara.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface IOpcao { value: number; label: string; }

export default function DefensoriaEditPage() {
  const { register, handleSubmit, reset, getValues, setValue, control } = useForm<ReadDefensoriaDto>();
  const { setActions } = useBreadcrumbActions();

  const { field: fielddefensoriasubstituta1 } = useController({ name: 'defensoriasubstituta1', control });
  const { field: fielddefensoriasubstituta2 } = useController({ name: 'defensoriasubstituta2', control });
  const { field: fielddiretoria } = useController({ name: 'diretoria', control });

  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Defensoria_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  const [varas, setVaras] = useState<IOpcao[]>([]);
  const [comarcas, setComarcas] = useState<IOpcao[]>([]);
  const [predios, setPredios] = useState<IOpcao[]>([]);
  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [diretorias, setDiretorias] = useState<IOpcao[]>([]);
  const [loaded, setLoaded] = useState<boolean>(false);

  async function buscar() {
    if (id > 0)
      await GetDefensoria(id)
        .then((result) => {
          if (result)
            if (result.telefone && result.telefone.numero)
              result.telefone.numero = FormataTelefone(result.telefone.numero);
          reset(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }

  useEffect(() => {
    Promise.all([
      readVara({ skip: 0, take: 1000 }).then((result) => {
        setVaras(
          result[0].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      readComarca({ skip: 0, take: 1000 }).then((result) => {
        setComarcas(
          result[0].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetPredios(0, 1000).then((result) => {
        setPredios(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetDefensorias(0, 1000).then((result) => {
        setDefensorias(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetDiretorias(0, 1000).then((result) => {
        setDiretorias(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      buscar(),
    ])
      .then(() => setLoaded(true))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  const onSubmit: SubmitHandler<ReadDefensoriaDto> = (data) => {
    setIsLoading(true);
    const dados: ReadDefensoriaDto = {
      id: id,
      comarca: { id: Number(data.comarca?.id) },
      defensoriasubstituta1: {
        id: Number(data.defensoriasubstituta1?.id),
      },
      defensoriasubstituta2: {
        id: Number(data.defensoriasubstituta2?.id),
      },
      nome: data.nome,
      codigo: data.codigo,
      ordem: data.ordem,
      predio: { id: Number(data.predio?.id) },
      vara: { id: Number(data.vara?.id) },
      exibirrelatorio: data.exibirrelatorio,
      maximo_estagiarios: data.maximo_estagiarios,
      anotacao: data.anotacao,
      telefone: data.telefone,
      diretoria: data.diretoria?.id ? { id: Number(data.diretoria.id) } : undefined,
    } as ReadDefensoriaDto;

    SetDefensoria(dados)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Defensoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    DeleteDefensoria(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Defensoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Defensoria</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="col-md-1">
            <label htmlFor="ordem" className="form-label">
              Ordem:{' '}
            </label>
            <input
              id="ordem"
              title="Ordem no relatório"
              type="number"
              className="form-control"
              min={0}
              {...register('ordem')}
              defaultValue={0}
            />
            <div
              className="mb-3 col-md-1 form-check"
              title="Exibir no relatório de lotações."
            >
              <input
                id="ativo"
                type="checkbox"
                className="form-check-input"
                {...register('exibirrelatorio')}
              />
              <label className="form-check-label" htmlFor="ativo">
                Relatório
              </label>
            </div>
          </div>

          <div className="col-md-2">
            <div>
              <label htmlFor="nome" className="form-label">
                Código:{' '}
              </label>
              <input
                title="nome"
                type="text"
                className="form-control"
                {...register('codigo')}
              />
            </div>
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="nome" className="form-label">
              Nome Defensoria:{' '}
            </label>
            <input
              title="nome"
              type="text"
              className="form-control"
              {...register('nome')}
            />
          </div>

          <div className="mb-3 col-md-3">
            <label htmlFor="vara" className="form-label">
              Vara:{' '}
            </label>
            <select
              id="id"
              title="Vara"
              className="form-select"
              {...register('vara.id')}
            >
              {varas.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="defensoriasubstituta1" className="form-label">
              1ª Defensoria Substituta:{' '}
            </label>
            <Select
              id="defensoriasubstituta1"
              name="defensoriasubstituta1"
              isClearable
              options={[{ label: '', value: '' }, ...defensorias]}
              value={
                fielddefensoriasubstituta1.value
                  ? defensorias.find(
                    (a) => a.value === fielddefensoriasubstituta1.value?.id,
                  )
                  : { label: '', value: '' }
              }
              onChange={(e) => {
                const defSelecionada = defensorias!.find(
                  (a) => a.value === e?.value,
                );
                const novaDefensoria = defSelecionada
                  ? ({
                    id: defSelecionada.value,
                    nome: defSelecionada.label,
                  } as ReadDefensoriaDto)
                  : undefined;
                fielddefensoriasubstituta1.onChange(novaDefensoria);
              }}
              onBlur={fielddefensoriasubstituta1.onBlur}
            />
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="defensoriasubstituta2" className="form-label">
              2° Defensoria Subsitituta:{' '}
            </label>
            <Select
              id="defensoriasubstituta2"
              name="defensoriasubstituta2"
              isClearable
              options={[{ label: '', value: '' }, ...defensorias]}
              value={
                fielddefensoriasubstituta2.value
                  ? defensorias.find(
                    (a) => a.value === fielddefensoriasubstituta2.value?.id,
                  )
                  : { label: '', value: '' }
              }
              onChange={(e) => {
                const defSelecionada = defensorias!.find(
                  (a) => a.value === e?.value,
                );
                const novaDefensoria = defSelecionada
                  ? ({
                    id: defSelecionada.value,
                    nome: defSelecionada.label,
                  } as ReadDefensoriaDto)
                  : undefined;
                fielddefensoriasubstituta2.onChange(novaDefensoria);
              }}
              onBlur={fielddefensoriasubstituta2.onBlur}
            />
          </div>
          <div className="col-md-8 row">
            <div className="mb-3 col-md-6">
              <label htmlFor="comarca" className="form-label">
                Comarca:{' '}
              </label>
              <select
                id="comarca"
                title="Comarca"
                className="form-select"
                {...register('comarca.id')}
              >
                {comarcas.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="predio" className="form-label">
                Unidade:{' '}
              </label>
              <select
                title="Prédio"
                className="form-select"
                {...register('predio.id')}
              >
                {predios.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="diretoria" className="form-label">
                Diretoria:{' '}
              </label>
              <Select
                id="diretoria"
                name="diretoria"
                isClearable
                options={[{ label: '', value: '' }, ...diretorias]}
                value={
                  fielddiretoria.value
                    ? diretorias.find(
                      (a) => a.value === fielddiretoria.value?.id,
                    )
                    : { label: '', value: '' }
                }
                onChange={(e) => {
                  const dirSelecionada = diretorias!.find(
                    (a) => a.value === e?.value,
                  );
                  const novaDiretoria = dirSelecionada
                    ? ({
                      id: dirSelecionada.value,
                      nome: dirSelecionada.label,
                    } as any)
                    : undefined;
                  fielddiretoria.onChange(novaDiretoria);
                }}
                onBlur={fielddiretoria.onBlur}
              />
            </div>

            <div className="mb-3 col-md-3">
              <label htmlFor="maximo_estagiarios" className="form-label">
                Max. Estagiarios:{' '}
              </label>
              <input
                id="maximo_estagiarios"
                title="Máximo de estagiários"
                type="number"
                className="form-control"
                min={0}
                max={99}
                {...register('maximo_estagiarios')}
              />
            </div>

            <div className="mb-3 col-md-9" title="Anotações ou observações">
              <label htmlFor="anotacao" className="form-label">
                Anotações:
              </label>
              <input
                id="anotacao"
                type="text"
                className="form-control"
                {...register('anotacao')}
              />
            </div>
          </div>

          <div className="col-md-4 p-3">
            <div className="card">
              <div className="card-body row">
                <div className="mb-3 col-md-4">
                  <label htmlFor="ddd" className="form-label">
                    DDD:
                  </label>
                  <input
                    id="ddd"
                    title="DDD"
                    type="number"
                    className="form-control"
                    {...register('telefone.ddd')}
                    min={0}
                    max={99}
                    defaultValue={79}
                  />
                </div>
                <div className="mb-3 col-md-8">
                  <label htmlFor="numero" className="form-label">
                    Telefone:
                  </label>
                  <input
                    id="numero"
                    title="Númnero Telefone"
                    type="text"
                    className="form-control"
                    maxLength={10}
                    {...register('telefone.numero', {
                      onChange: (e) => {
                        const value = e.target.value;
                        setValue('telefone.numero', FormataTelefone(value));
                      },
                    })}
                  />
                </div>
              </div>
            </div>
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: { username: getValues().editadoPor?.username },
              editadoEm: getValues().editadoEm,
            }}
          />
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.defensoria}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
